<script>
    import {TextInput} from '$m7-library/main';
    import {t} from '$utils/lang.js';

    let {
        phone = $bindable(''),
        prefilled = false,
    } = $props();

    const hasPhone = $derived(phone && phone.trim().length > 5);

    const wrapperCls = $derived(
        hasPhone
            ? 'border-green bg-green/5'
            : 'border-warning-border bg-warning-bg',
    );
</script>

<div class={`border-2 rounded-lg p-4 flex flex-col gap-2 ${wrapperCls}`}>
    <div class="flex items-center gap-2">
        <span class="size-3.5 rounded-full" class:bg-green={hasPhone} class:bg-warning-border={!hasPhone}></span>
        <span class="font-bold text-xsm" class:text-black={hasPhone} class:text-warning-text={!hasPhone}>
            {hasPhone ? t('Telefonnummer hinterlegt') : t('Telefonnummer erforderlich')}
        </span>
    </div>
    <TextInput
        name="phone"
        bind:value={phone}
        label={t('Telefonnummer')}
        placeholder="+49 123 456789"
        autocomplete="tel"
    />
    <p class="text-xs leading-tight" class:text-gray-103={hasPhone} class:text-warning-text={!hasPhone}>
        {hasPhone && prefilled
            ? t('Die Nummer wurde aus deinen Kontodaten übernommen und kann bei Bedarf geändert werden.')
            : t('Für die Zustellung deiner Bestellung benötigen wir deine Telefonnummer.')}
    </p>
</div>
